const enGB = {
  navigation: {
    mydevice: "Min enhet",
    mymobile: "Min mobil"
  },
  photoorganiser: {
    navigation: {
      photos: "Bilder",
      favorites: "Favoriter",
      collections: "Album",
      events: "Händelser",
      latestuploads: "Senaste uppladdningar"
    },
    empty(source) {
      return "Du har inga bilder i " + source
    }
  },
  mymobile: {
    title: "Hämta dina mobilbilder på nolltid!",
    qrcode: {
      title: "Scanna QR-kod",
      subtitle: "(du behöver inte installera appen)"
    },
    instruction: {
      title: "Låt oss starta",
      step_1: "Öppna din kamera",
      step_2: "Scanna QR-kod",
      step_3: "Följ instuktionerna på mobilen"
    }
  },
  layout: {
    flex: "Flexibel",
    square: "Kvadratisk"
  },
  calender: {
    allmonths: "Alla månader",
    allyears: "Alla år",
    months: {
      january: "Januari",
      february: "Februari",
      march: "Mars",
      april: "April",
      may: "Maj",
      june: "Juni",
      july: "Juli",
      august: "Augusti",
      september: "September",
      october: "Oktober",
      november: "November",
      december: "December"
    }
  },
  generic: {
    sortBy: "Ordna efter",
    selected: "Valda",
    done: "Lägg till bilder",
    back: "Tillbaka",
    images: "Bilder",
    selection: "Urval",
    date: "Datum",
    name: "Namn",
    az: "Filnamn A-Ö",
    za: "Filnamn Ö-A",
    newestfirst: "Datum valt nytt-gammalt",
    oldestfirst: "Datum valt gammalt-nytt",
    photos: "Bilder",
    all: "Alla",
    yes: "Ja",
    no: "Nej",
    nodate: "Utan datum"
  },
  rangeText: {
    minMax(min, max) {
      return "Du måste välja mellan " + min + " och " + max + " bilder"
    },
    min(min) {
      return "Du behöver minst " + min + " bilder för att skapa din bok."
    },
    max(max) {
      return "Du kan högst välja " + max + "  bilder"
    }
  },
  addMorePhotos: "Lägg till fler bilder",
  upload: {
    browseButton: "Lägg till bilder",
    uploadlimit(maxSize) {
      return "Bilder måste vara mindre än " + maxSize + " i filstorlek"
    },
    dragImage: "eller dra och släpp foton här.",
    errors: {
      GENERIC_ERROR: "Något gick tyvärr fel. Försök igen eller kontakta kundtjänst.",
      EMPTY_FILE: "Bildreferens förlorades. Lägg till bild igen",
      MAX_FILE_SIZE: "Filen måste vara mindre än {0} mb",
      UNSUPPORTED_FILE_TYPE: "Filformat stöds inte",
      MAX_IMAGE_RESOLUTION: "Filen måste vara mindre än {0} pixels",
      INVALID_IMAGE: "Filen är trasig"
    },
    errorSummary(number) {
      return number + " filer kunde inte laddas upp"
    },
    errorDialog: {
      headline: "Hoppsan!",
      ingress: "Följande filer kunde inte laddas upp:",
      filenameColumn: "Fil",
      reasonColumn: "Orsak"
    },
    uploaded: "Uppladdning genomförd",
    estimating: "Tid beräknas",
    estimatedleft: "Beräknad tid som återstår",
    ok: "OK",
    cancel: "Avbryt",
    details: "Detaljer"
  }
}

export default enGB
